import { render, staticRenderFns } from "./GalleriesDropDown.vue?vue&type=template&id=4a500dd7&scoped=true&"
import script from "./GalleriesDropDown.vue?vue&type=script&lang=js&"
export * from "./GalleriesDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a500dd7",
  null
  
)

export default component.exports